<template>

    <BnOffsetCard blockTitle="Üzembentartó (szerződő) adatai" :sectionFinished="false">

        <BnUgyfelKivalaszt
            v-if="!$online && !isPapirmentes"
            ref="ugyfelkivalaszto"
            slot="header"
            :path="path"
        />

        <div slot="block-elements">

            <v-form :ref="path + '_adatok'">

                <v-layout row wrap>

                    <BnFormField
                        :attributes="{
                                label: 'A biztosítás szerződője',
                                visible: true,
                                editable: editable && !isPapirmentes,
                                type: 'select',
                                mezo: this.path + '.sex',
                                path: this.path + '.sex',
                                options: [
                                       {key: 1, value: 'Férfi'},
                                       {key: 2, value: 'Nő'},
                                       {key: 3, value: 'Nem természetes személy'},
                                ],
                                itemsText: 'value',
                                itemsValue: 'key',
                            }"
                    />

                    <BnFormField key="birthdate_input" v-if="isPerson"
                                 :attributes="{
                                    label: 'Születési ideje',
                                    visible: true,
                                    editable: editable  && !isPapirmentes,
                                    path: this.path + '.birthdate',
                                    mezo: this.path + '.birthdate',
                                    type: 'date',
                                    blur: ugyfelKeresOpen,
                                 }
                    "/>
                    <BnFormField v-if="isPerson"
                                 :attributes="{
                                    label: 'Titulus',
                                    editable: editable && !isPapirmentes,
                                    visible: true,
                                    path: this.path + '.titulus',
                                    mezo: this.path + '.titulus',
                                    type: 'select',
                                    resource: listTypes.titulus,
                                    itemsText: 'value',
                                    itemsValue: 'key',
                               }"
                    />
                    <BnFormField key="name_input" v-if="isPerson"
                                 :attributes="{
                                    label: 'Neve',
                                    editable: editable && !isPapirmentes,
                                    visible: true,
                                    path: this.path + '.name',
                                    mezo: this.path + '.name',
                                    type: 'text',
                                    textTransform: capitalize,
                                    blur: ugyfelKeresOpen,
                               }"
                    />

                    <!--region CSAK CÉGES ADATOK -->

                    <BnFormField v-if="isCompany"
                                 :attributes="{
                                    label: 'Neve',
                                    visible: true,
                                    editable: editable,
                                    path: this.path + '.cegnev',
                                    mezo: this.path + '.cegnev',
                                    type: 'text',
                              }"
                    />
                    <BnFormField v-if="isCompany"
                                 :attributes="{
                                    label: 'Cégforma',
                                    visible: true,
                                    editable: editable,
                                    path: this.path + '.cegforma',
                                    mezo: this.path + '.cegforma',
                                    type: 'select',
                                    resource: listTypes.cegforma,
                                    itemsText: 'value',
                                    itemsValue: 'key',
                              }"
                                 key="cegforma_input_field"
                    />
                    <BnFormField v-if="isCompany"
                                 :attributes="{
                                    label: 'Adószáma',
                                    visible: true,
                                    editable: editable,
                                    path: this.path + '.company_taxnumber',
                                    mezo: this.path + '.company_taxnumber',
                                    type: 'text',
                                    mask: '###########',
                                }"
                    />
                    <BnTeaorInput v-if="isCompany"
                                 :attributes="{
                                    editable: editable,
                                    path: this.path + '.teaor',
                                    mezo: this.path + '.teaor',
                                 }"
                                 key="teaor_input_field"
                    />
                    <!-- endregion -->
                </v-layout>

                <v-layout row wrap>

                    <BnIrszam
                        v-if="isPerson || isCompany"
                        :attributes="{
                                        label: getValue(this.path+'.'+ 'sex') == 3
                                        ? 'Székhely irányítószáma'
                                        : 'Irányítószám',
                                        visible: true,
                                        editable: !isPapirmentes,
                                        path: this.path + '.' + 'address.zip',
                                        mezo: 'uzembentarto.cim.zip',
                                        width: 'xs12 md6'
                                    }">
                    </BnIrszam>

                    <BnVaros
                        v-if="isPerson || isCompany"
                        :zip="$store.getters.uzembentarto.address.zip"
                        :attributes="{
                                        label: 'Település',
                                        visible: true,
                                        editable: !isPapirmentes,
                                        path: this.path + '.' + 'address.city_code',
                                        mezo: 'uzembentarto.cim.city_code',
                                        width: 'xs12 md6'
                                    }">
                    </BnVaros>

                    <!--                    TODO: only if online -->
                    <BnFormField v-if="isPerson || isCompany"
                                 :attributes="{
                                    label: 'E-mail',
                                    visible: true,
                                    editable: editable,
                                    path: this.path + '.email',
                                    mezo: this.path + '.email',
                                    type: 'email',
                              }"
                    />

                    <!--                    TODO: only if online -->
                    <BnFormField v-if="isPerson || isCompany"
                                 :attributes="{
                                    label: 'Telefonszám',
                                    visible: true,
                                    editable: editable,
                                    path: this.path + '.mobil',
                                    mezo: this.path + '.telefon',
                                    type: 'text',
                              }"
                    />

                </v-layout>

                <BnFormField
                    v-if="isCompany"
                    :attributes="{
                                    label: 'A forgalmiban szereplő cím megegyezik a székhellyel.',
                                    visible: true,
                                    editable: editable,
                                    path: 'tarifaData.forgcim_megegyezik',
                                    mezo: 'forgcim_megegyezik',
                                    type: 'checkbox',
                                    width: 'md12 xs12'
                                }"
                />

                <v-layout row wrap v-if="getValue('tarifaData.forgcim_megegyezik') !== true && isCompany">

                    <BnIrszam
                        v-if="isPerson || isCompany"
                        :attributes="{
                                        label: 'Forgalmiban szereplő irányítószám',
                                        visible: true,
                                        editable: true,
                                        path: 'tarifaData.forgalmi_cim.zip',
                                        mezo: 'uzembentarto.forgalmi_cim.zip',
                                        width: 'xs12 md6'
                                    }">
                    </BnIrszam>

                    <BnVaros
                        v-if="isPerson || isCompany"
                        :zip="$store.getters.tarifaData.forgalmi_cim.zip"
                        :attributes="{
                                        label: 'Település',
                                        visible: true,
                                        editable: true,
                                        path: 'tarifaData.forgalmi_cim.city_code',
                                        mezo: 'uzembentarto.forgalmi_cim.city_code',
                                        width: 'xs12 md6'
                                    }">
                    </BnVaros>

                </v-layout>
                <!-- endregion -->

                <v-layout row wrap>

                    <v-flex class="ma-2">
                        <v-divider/>
                    </v-flex>

                    <BnFormField v-if="isCompany"
                                 :attributes="{
                                    label: 'Kér papíralapú számlát?',
                                    visible: true,
                                    editable: editable,
                                    path: 'tarifaData.ker_szamla',
                                    mezo: 'uzembentarto.ker_szamla',
                                    type: 'select',
                                    resource: listTypes.yesno,
                                    itemsText: 'key',
                                    itemsValue: 'value',
                          }"
                    />

                    <BnFormField v-if="isCompany"
                                 :attributes="{
                                    label: 'Rendelkezik-e gépjármű kereskedelemi engedéllyel?',
                                    visible: true,
                                    editable: editable,
                                    path: 'tarifaData.gepjker_eng',
                                    mezo: 'uzembentarto.gepjker_eng',
                                    type: 'select',
                                    resource: listTypes.rendelkezem,
                                    itemsText: 'key',
                                    itemsValue: 'value',
                                }"
                    />

                    <BnFormField v-if="isCompany"
                                 :attributes="{
                                    label: 'Rendelkezik-e gépjármű kölcsönzési engedéllyel?',
                                    visible: true,
                                    editable: editable,
                                    path: 'tarifaData.gepjkolcs_eng',
                                    mezo: 'uzembentarto.gepjkolcs_eng',
                                    type: 'select',
                                    resource: listTypes.rendelkezem,
                                    itemsText: 'key',
                                    itemsValue: 'value',
                                }"
                    />
                    <!--<BnFormFieldFullWidth v-if="getValue(this.path + '.' + 'sex') == 3"
                                 :attributes="{
                                label: 'Rendelkezik-e fuvarozói engedéllyel?',
                                visible: true,
                                editable: true,
                                path: 'tarifaData.egyeb_nemzetkozi',
                                mezo: 'egyeb_nemzetkozi',
                                type: 'select',
                                resource: listTypes.rendelkezem,
                                itemsText: 'key',
                                itemsValue: 'value',
                                rules: [(v) => rules.required(v,
                                'Adja meg, hogy az üzembentartó rendelkezik-e fuvarozói engedéllyel!')]
                            }"
                    ></BnFormFieldFullWidth> -->
                </v-layout>

                <v-layout row wrap>

                    <BnFormField v-if="isPerson"
                                 :attributes="{
                            label: 'Rendelkezik jogosítvánnyal',
                            visible: true,
                            editable: editable && !isPapirmentes,
                            mezo: this.path + '.has_licence',
                            type: 'select',
                            path: this.path + '.has_licence',
                            resource: listTypes.yesno,
                            itemsText: 'key',
                            itemsValue: 'value',
                        }"
                    />

                    <BnFormField
                        v-if="getValue(this.path + '.' + 'has_licence') && isPerson"
                        :attributes="{
                            label: 'Jogosítvány megszerzésének a dátuma',
                            visible: true,
                            editable: editable && !isPapirmentes,
                            mezo: this.path + '.jogsi_datum',
                            type: 'date',
                            path: this.path + '.licence_date',
                        }"
                    />

                    <BnFormField v-if="isPerson"
                                 :attributes="{
                            label: 'A legfiatalabb gyermek születési éve',
                            visible: true,
                            editable: editable,
                            type: 'select',
                            path: 'tarifaData.ajanl_gyerek_szulev',
                            mezo: 'ajanl_gyerek_szulev',
                            resource: listTypes.gyerekEv,
                            itemsText: 'value',
                            itemsValue: 'key'
                        }"
                    />

                    <BnFormField v-if="isPerson && vanGfb"
                                 :attributes="{
                            label: 'Az Ön foglalkozása, tevékenysége',
                            visible: true,
                            editable: editable,
                            type: 'select',
                            path: 'tarifaData.mkb_munkahely',
                            mezo: 'mkb_munkahely',
                            resource: listTypes.mkb_munkahely,
                            itemsText: 'value',
                            itemsValue: 'key'
                        }"
                    />

                    <BnFormField v-if="isPerson && vanGfb"
                                 :attributes="{
                            label: 'Az Ön házastársa közszolgálati dolgozó?',
                            visible: true,
                            editable: editable,
                            type: 'select',
                            path: 'tarifaData.ajanl_kozszolga',
                            mezo: 'ajanl_kozszolga',
                            resource: listTypes.yesno,
                            itemsText: 'key',
                            itemsValue: 'value',
                        }"
                    />

                    <BnFormField v-if="isPerson && vanGfb"
                                 :attributes="{
                            label: 'Ön vagy közeli hozzátartozója polgárőr-e?',
                            visible: true,
                            editable: editable,
                            type: 'select',
                            path: 'tarifaData.polgaror',
                            mezo: 'polgaror',
                            options: [
                                {key: 'N', value: 'Nem'},
                                {key: 'Y', value: 'Igen a szerződő polgárőr'},
                                {key: 'K', value: 'Igen a szerződő közeli hozzátartozója polgárőr'},
                            ],
                            itemsValue: 'key',
                            itemsText: 'value'
                        }"
                    />

                    <BnFormField v-if="isPerson && vanGfb"
                                 :attributes="{
                            label: 'Ön nyugdíjas?',
                            visible: true,
                            editable: editable,
                            type: 'select',
                            path: 'tarifaData.ajanl_nyugdijas',
                            mezo: 'ajanl_nyugdijas',
                            resource: listTypes.yesno,
                            itemsText: 'key',
                            itemsValue: 'value'
                        }"
                    />

                    <BnFormField v-if="isPerson && vanGfb"
                                 :attributes="{
                            label: 'Ön mozgáskorlátozott?',
                            visible: true,
                            editable: editable,
                            type: 'select',
                            path: 'tarifaData.ajanl_mozgaskorlatozott',
                            mezo: 'ajanl_mozgaskorlatozott',
                            resource: listTypes.mozgaskorlatozott,
                            itemsText: 'value',
                            itemsValue: 'key',
                        }"
                    />
                </v-layout>

            </v-form>

        </div>

    </BnOffsetCard>

</template>

<script>
import { listTypes } from '../../modules/List';
import { capitalize } from '../../filters/capitalize';
import modozat from '../gfb/shared/mixins/modozat';
import ugyfelTorzsService from '../../services/UgyfeltorzsService';
import Papirmentes from '../gfb/uzletkoto/mixins/Papirmentes';
import BnTeaorInput from './BnTeaorInput.vue';

export default {
    name: 'BnBaseUgyfel',
    components: {BnTeaorInput},
    mixins: [
        modozat,
        Papirmentes,
    ],
    data() {
        return {
            listTypes,
        };
    },
    props: {
        path: {
            type: String,
            default: 'ugyfel',
        },
        egyebLabel: {
            type: String,
            default: null,
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        urlVars() {
            return this.$route.params;
        },
        isPerson() {
            return typeof this.getValue(`${this.path}.sex`) !== 'undefined'
                && this.getValue(`${this.path}.sex`) !== 3;
        },

        isCompany() {
            return typeof this.getValue(`${this.path}.sex`) !== 'undefined'
                && this.getValue(`${this.path}.sex`) === 3;
        },
    },
    mounted() {
        if (this.urlVars.papirmentes === '1' && !this.$online) {
            this.$store.commit('setPapirmentes', true);
            if (typeof this.urlVars.ugyfazon === 'string') {
                ugyfelTorzsService.getUgyfel(
                    this.urlVars.ugyfazon, [2, 4],
                ).then(
                    (response) => {
                        this.$store.dispatch('setUgyfel', {
                            value: response.data.ugyfel,
                            path: 'uzembentarto',
                        });
                    },
                );
            } else {
                throw new Error('Error while loading existing customer data BnBaseUgyfel');
            }
        }
    },
    methods: {
        ugyfelKeresOpen() {
            if (this.$online) return;
            this.$refs.ugyfelkivalaszto.openUgyfelKivalaszto({
                nem: this.$store.getters[this.path].sex,
                nev: this.$store.getters[this.path].name,
                szulido: this.$store.getters[this.path].birthdate,
            });
        },
        capitalize,
        updateVarosLista() {
            this.$refs.varos.updateVarosLista();
        },
        updateForgalmiVarosLista() {
            this.$refs['forgalmi-varos'].updateVarosLista();
        },
        getValue(propName) {
            return this.$getNestedPropVal(this.$store.getters, propName.split('.'));
        },
        setValue(value, propName) {
            this.$store.commit('setProp', {
                path: `${this.path}.${propName}`,
                value,
            });
        },
        isUzembentarto() {
            return this.path === 'uzembentarto';
        },
    },
};
</script>
